import { render, staticRenderFns } from "./FinishedProductMaterialOrderReminder.vue?vue&type=template&id=21d121c0&scoped=true&"
import script from "./FinishedProductMaterialOrderReminder.vue?vue&type=script&lang=js&"
export * from "./FinishedProductMaterialOrderReminder.vue?vue&type=script&lang=js&"
import style0 from "./FinishedProductMaterialOrderReminder.vue?vue&type=style&index=0&id=21d121c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d121c0",
  null
  
)

export default component.exports